import { Button, Modal, Typography } from "antd"
import { CloseOutlined } from "@ant-design/icons"

const { Text } = Typography

interface ModelDialogProps {
    open: boolean
    width?: number
    onSure?: () => void
    onCancel?: () => void
    title?: string | null
    children?: React.ReactNode
    sureText?: string
    cancelText?: string
    closable?: boolean
}

export default function ModelDialog({
    open,
    width = 460,
    onSure,
    onCancel,
    title = '',
    children,
    sureText = '确定',
    cancelText = '取消',
    closable: _closable = false,
}: ModelDialogProps) {
    return (
        <Modal
            open={open}
            onCancel={onCancel}
            title={null}
            closable={false}
            footer={null}
            centered
            width={width}
            destroyOnHidden
            styles={{
                mask: {
                    background: 'rgba(0, 0, 0, .6)',
                    backdropFilter: 'blur(4px)',
                },
                container: {
                    background: 'var(--bg-panel)',
                    borderRadius: 16,
                    border: '1px solid rgba(255,255,255,0.08)',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.45)',
                    padding: 28,
                }
            }}
        >
            {title && 
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 16,
                    }}
                >
                    <Text style={{ color: '#fff', fontSize: 17, fontWeight: 600 }}>
                        {title}
                    </Text>
                    <CloseOutlined onClick={onCancel} style={{ fontSize: 17, color: ' var(--text-3)', cursor: 'pointer' }} />
                </div>
            }
            {children}
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={onCancel}>{cancelText}</Button>
                {
                    onSure && <Button type="primary" onClick={onSure} style={{ marginLeft: 16 }}>{sureText}</Button>
                }
            </div>
        </Modal>
    )
}